import { Component, Input, OnInit } from '@angular/core';
import {
  AlertService,
  ComponentsStoreService,
  FileStoreService,
  IAlertType,
} from '../../../../_shared/services';
import { Components, Files } from '../../../../_shared/interfaces';
import { saveAs } from 'file-saver';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrModalModule } from "@clr/angular";
import { environment as env } from "../../../../../environments/environment";
import { filesBaseUrl } from "../../../../_shared/utils/rest-url";
import { NgIf } from "@angular/common";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { UploadComponent } from "../../../../core/upload/upload.component";
import { TranslocoDirective } from "@jsverse/transloco";
import { ClarityIcons, timesCircleIcon } from "@cds/core/icon";
import {HttpClient} from "@angular/common/http";
import { getTenantStorage } from '../../../../_shared/utils/tenant-context';

@Component({
  selector: 'app-request-details-documents',
  standalone: true,
  imports: [
    ClrDatagridModule,
    NgIf,
    ClrModalModule,
    NgxExtendedPdfViewerModule,
    UploadComponent,
    TranslocoDirective
  ],
  templateUrl: './request-details-documents.component.html',
  styleUrl: './request-details-documents.component.sass'
})
export class RequestDetailsDocumentsComponent implements OnInit {
  companyId: number = 0;
  components: Components[] = [];
  requestsFiles: Files[] = [];
  public showPdf = false;
  public showFileUpload = false;
  modalContent: string = '';
  modalUrl: string = '';
  public loading: boolean = true;
  descSort = ClrDatagridSortOrder.DESC;

  private filesDirectory = filesBaseUrl();

  @Input() requestId: number = 0;
  @Input() projectId: string = '';

  constructor(
    private componentsService: ComponentsStoreService,
    private alertDispatcher: AlertService,
    private fileService: FileStoreService,
    private http: HttpClient,
  ) {
    ClarityIcons.addIcons(timesCircleIcon)
  }

  ngOnInit() {
    this.getFilesSet([10], this.projectId);
  }

  showModal(fileId: string, modalTitle: string) {
    const phmToken = getTenantStorage('access_token');
    let fileUrl: string;
    this.modalContent = modalTitle;
    fileUrl = `${this.filesDirectory}/download_file?file_id=${fileId}&token=${phmToken}`;

    this.http.get(fileUrl, { responseType: 'blob' }).subscribe(blob => {
      const blobUrl = URL.createObjectURL(blob);
      this.modalUrl = blobUrl;
    });

    this.showPdf = true;
  }

  closeModal(state: boolean) {
    this.showFileUpload = state;
    this.loading = true;
    this.getFilesSet([10], this.projectId);
  }

  showFileUploader() {
    this.showFileUpload = true;
  }

  private getFilesSet(docType: number[], projectId: string) {
    this.fileService.getFilesSet(docType, projectId, 0, this.requestId).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.requestsFiles = [];
          this.alertDispatcher.alertConfig.message = 'Keine Dateien gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.requestsFiles = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return}
    })
  }

  deleteFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.fileService.deleteFile(fileId)
        .subscribe({
          next: () => {
            this.requestsFiles = this.requestsFiles.filter(file => file.id !== fileId);
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde gelöscht. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
          },
          complete: () => {
            this.getFilesSet([10], this.projectId);
          },
          error: () => {
            return
          }
        })
    }
  }

  loadFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' herunterladen?')) {
      this.fileService.downloadFile(fileId)
        .subscribe({
          next: data => {
            if (!data) {
              this.alertDispatcher.alertConfig.message = 'Keine Datei gefunden!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
              return;
            }
            saveAs(data, fileName);
          },
          complete: () => {
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde heruntergeladen. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
          },
          error: () => {
            return
          }
        })
    }
  }
}
